import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, TrendingUpIcon } from 'lucide-react';
export function ProofSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 relative" data-id="element-137">
      <div className="max-w-4xl mx-auto" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="glass-card rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-139">
          <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-cyan-accent/10 to-transparent pointer-events-none" data-id="element-140" />

          <h2 className="text-3xl md:text-4xl font-bold text-white mb-10 relative z-10" data-id="element-141">
            Lo Que Cambia en 7 Días
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-10 relative z-10" data-id="element-142">
            <div className="bg-navy-900/80 rounded-2xl p-6 border border-cyan-accent/20" data-id="element-143">
              <ZapIcon className="w-10 h-10 text-cyan-glow mx-auto mb-4" data-id="element-144" />
              <div className="text-4xl font-black text-white mb-2" data-id="element-145">
                <span className="text-gray-500 line-through text-2xl mr-2" data-id="element-146">
                  40 min
                </span>
                <span className="text-cyan-glow" data-id="element-147">2 min</span>
              </div>
              <p className="text-gray-400 text-sm" data-id="element-148">Tiempo promedio por tarea</p>
            </div>

            <div className="bg-navy-900/80 rounded-2xl p-6 border border-cyan-accent/20" data-id="element-149">
              <TrendingUpIcon className="w-10 h-10 text-cyan-glow mx-auto mb-4" data-id="element-150" />
              <div className="text-4xl font-black text-cyan-glow mb-2" data-id="element-151">5x</div>
              <p className="text-gray-400 text-sm" data-id="element-152">Multiplicador de output</p>
            </div>
          </div>

          <p className="text-xl text-gray-300 leading-relaxed relative z-10" data-id="element-153">
            Pasarás de pasar 40 minutos corrigiendo textos mediocres a generar
            reportes, correos y estrategias de nivel experto en menos de 2
            minutos. Tu capacidad de salida (output) se multiplicará por 5
            eliminando el bloqueo de la hoja en blanco para siempre.
          </p>
        </motion.div>
      </div>
    </section>;
}